import { ClaimantsInitialState } from '../types/claimantsSliceTypes';

export const claimantsSliceInitialState: ClaimantsInitialState = {
  claimantsListByClaimId: {},
  statuses: {
    isClaimantsListLoading: false,
  },
};
